import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { EnvironmentOptionsService } from '@cardium/features/option/data-access';
import { AUTH_LOGIN_PAGE_CONFIG } from '@cardium/features/auth/data-access';

export function provideAuthGlobalConfig(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: AUTH_LOGIN_PAGE_CONFIG,
      useFactory: () => {
        const env = inject(EnvironmentOptionsService);

        return {
          headerTitle:
            env.userForm()?.value === 'RADIUM' ? 'Радиум' : 'Кардиум',
        };
      },
    },
  ]);
}
